import { baseUrl } from "@/consts";
import { Product } from "@/interfaces";
import {
  formatCurrency,
  isNonEmptyString,
  isNumber,
  roundCurrency,
} from "@/utils";

export class ProductHelper {
  public static readonly FULFILLMENT_OFF_SITE_STRING = "Off-Site";
  public static readonly FULFILLMENT_IN_STORE_STRING = "In-Store";

  static getBarcodeUrl = (product?: Product) => {
    const data = ProductHelper.getBarcodeData(product);
    const dataAbove = ProductHelper.getBarcodeDataAbove(product);
    const dataBelow = ProductHelper.getBarcodeDataBelow(product);

    return isNonEmptyString(data)
      ? `${baseUrl.BARCODE}/${data}/CODE_128${
          isNonEmptyString(dataAbove) ? `/${dataAbove}` : ""
        }${isNonEmptyString(dataBelow) ? `/${dataBelow}` : ""}`
      : "";
  };

  static getBarcodeData = (product?: Product) => product?.sku;

  static getBarcodeDataAbove = (product?: Product) => product?.supplierName;

  static getBarcodeDataBelow = (product?: Product) =>
    isNumber(product?.price)
      ? formatCurrency(roundCurrency(product!.price as number))
      : "";
}
